import { FiservCardPurse, FiservCardPurseStatusEnum, OptionKey } from '@common-fe/common-fe';

import { storeCreator } from '@/utils/store/store.utils';

interface State {
  state: {
    lockedPursesIds: string[];
    isCardLocked: boolean;
    lockReason: OptionKey;
  };
  handleToggleLockedPurse: (purseId: string, isLocked: boolean) => void;
  handleToggleCardLock: (isLocked: boolean) => void;
  handleSetLockReason: (lockReason: OptionKey) => void;
  handleSetLockedPurses: (purses: FiservCardPurse[]) => void;
  handleReset: () => void;
}

export const useStore = storeCreator<State>((set) => ({
  state: {
    lockedPursesIds: [],
    isCardLocked: false,
    lockReason: '',
  },
  handleToggleLockedPurse: (purseId, isLocked) => set((state) => ({
    ...state,
    state: {
      ...state.state,
      lockedPursesIds: isLocked
        ? [...state.state.lockedPursesIds, purseId]
        : state.state.lockedPursesIds.filter((id) => id !== purseId),
    },
  })),
  handleToggleCardLock: (isLocked) => set((state) => ({
    ...state,
    state: {
      ...state.state,
      isCardLocked: isLocked,
    },
  })),
  handleSetLockReason: (lockReason) => set((state) => ({
    ...state,
    state: {
      ...state.state,
      lockReason,
    },
  })),
  handleSetLockedPurses: (purses) => set((state) => ({
    ...state,
    state: {
      ...state.state,
      lockedPursesIds: purses
        .filter((purse) => purse.status === FiservCardPurseStatusEnum.FROZEN)
        .map((purse) => purse.id),
    },
  })),
  handleReset: () => set((state) => ({
    ...state,
    state: {
      ...state.state,
      lockedPursesIds: [],
      isCardLocked: false,
      lockReason: '',
    },
  })),
}));

export default () => {
  const store = useStore();
  return {
    ...store,
  };
};
